import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './insert-email.routes';
import api from '../../../components/api-service';
import util from '../../../components/util/util.module';
import emailService from '../../../components/email-service';

import 'angular-translate';
import feconClientBundle from '@infocert/fecon-client-bundle';
const translateModule = 'pascalprecht.translate';

import vcRecaptcha from 'angular-recaptcha';

export class InsertEmailController {

  constructor (notifier, $state, $log, iceApplicationPreferences, vcRecaptchaService, EmailService, LmrcApiService, queryParamGetter) {
    'ngInject';
    this._logger = $log.getInstance('InsertEmailController');
    this.notifier = notifier;
    this._$state = $state;
    this._emailService = EmailService;
    this._lmrcApiService = LmrcApiService;
    this._vcRecaptchaService = vcRecaptchaService;
    this._logger.debug("CREATED")
    this._prefs = iceApplicationPreferences;
    this._queryParamGetter = queryParamGetter;
    this.emailDomain = iceApplicationPreferences.getPref('features.insert-email.email-domain');
    this.accessType = 'master';
    this.username = null;
    this.recaptchaKey = iceApplicationPreferences.getPref('features.insert-email.grecaptcha-key');
    this.skipDisclosure = (iceApplicationPreferences.getPref('features.insert-email.skip-disclosure') === "true");
    this.loading= false;
  }

  $onInit() {
    this._logger.debug("INITIALIZING")
    const customizationId = _.trim(this._queryParamGetter('ui', true));
    if (customizationId) {
      this.loading=true;
      const that = this;
      that.personalizationId = customizationId;
      this._lmrcApiService.getCustomization(customizationId)
        .then(resp => {
          that. _logger.debug("getCustomization response", resp.data);
          if(resp.data.externalDomain){
            that._logger.debug("getCustomization setting external domain", resp.data.externalDomain);
            that.emailDomain = resp.data.externalDomain;
            that._logger.debug("DOMAIN CHANGED")
          }
          // recupera se e' una migrazione master o slave o multicasella
          if (resp.data.accessType){
            if (resp.data.accessType == "slave"){
              that.accessType = "slave";
            } else if (resp.data.accessType == "multi"){
              that.accessType = "multi"
            }
            else{
              that.accessType = "master"
            }
          }
          if (resp.data.skipTermsAndConditionsPhase) {
            that._logger.debug("getCustomization set skip disclosure", resp.data.skipTermsAndConditionsPhase);
            that.skipDisclosure = resp.data.skipTermsAndConditionsPhase;
          } else {
            that._logger.debug("getCustomization no customization for disclosure");
          }
          that.loading=false;
        }, err => {
          that._logger.warn("getCustomization failed, input disabled", err);
        });
    } else{
      this._logger.debug("getCustomization no customization")
    }
    this._logger.debug("INITIALIZED")
  }

  insertEmail(formValid){
    if(formValid){
      this.loading = true;
      this._logger.debug("insertEmail", this.inputEmail);
      this._logger.debug("recaptchaResponse", this.recaptchaResponse);
      this._emailService.setEmailUser(this.inputEmail);
      this._emailService.setEmailDomain(this.emailDomain);
      this._emailService.setAccessType(this.accessType);
      this._emailService.setUsername(this.username);
      this._emailService.setPersonalizationId(this.personalizationId);
      let request = {
        //user slave o multicasella da inserire nella request in caso accessType
        //nella view successiva devo assicurarmi che ci siano anche i campi username e il personalizationId
        'emailUser': this.inputEmail,
        'emailDomain': this.emailDomain,
        'username': this.username ? this.username : null,
        'personalizationId' : this.personalizationId ? this.personalizationId : null,
        'recaptchaResponse': this.recaptchaResponse
      };
      this._lmrcApiService.createSession(request).then(() => {
        this.loading = false;
        if (this.skipDisclosure == false){
          this._logger.debug("go to external.disclosure");
          this._$state.go("external.disclosure");
        } else {
            this.data={
              generalCondition: true,
              usageCondition: true,
              commercialAgreement: true,
              thirdPartyAgreement: true
            };

            this._lmrcApiService.updateUserAgreements(this.data).then(() => {
              this.loading = false;
              this._logger.debug("go to external.pec-import");
              this._$state.go("external.pec-import");
            }, (err) => {
              this.loading = false;
              this._logger.debug("updateUserAgreements failed", err);
              this.errorMessage = 'Si &egrave; verificato un errore. Si prega di riprovare';
            });
        }
      }, (err) => {
        this.loading = false;
        this._logger.debug("createSession failed", err);
        if (err.status === 401){
          this.errorMessage = 'verifica del google captcha non valido, si prega di riprovare';
        } else {
          this.errorMessage = 'Si &egrave; verificato un errore. Si prega di riprovare';
        }

        this._vcRecaptchaService.reload();
      });
    }
  }


}

export default angular.module('lmrcApp.insert-email', [
  uiRouter,

  translateModule,

  feconClientBundle,
  vcRecaptcha,
  util,
  api,
  emailService
])
  .config(routing)
  .component('insertEmail', {
    template: require('./insert-email.html'),
    controller: InsertEmailController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/features/insert-email/index.js